import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { Table, Input, Tooltip, Row, Col } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import { isMobile } from 'react-device-detect';
import { useCalculate } from '../../hooks/usePricing/useCalculate';
import { t } from '../common/Translate';
import { currencySign } from '../../Utils/currencySign';

const Calculate = ({ readOnly, monkFrevos }) => {
  const {
    userPricing,
    setValue,
    marketValue,
    refurbishmentCostCarcheck,
    rotation,
    listPlanedDelay,
    pricingAutobizResult,
    pricingUserResult,
    listVat,
    prixEt,
    prixEtUser,
    showET,
    bodyCosts,
    tradeInAutobiz,
    tradeInUser,
    tooltipOpen,
    setTooltipOpen,
    autobizRotation,
    setSecondTooltipOpen,
    aiReport,
    secondtooltipOpen,
    monkReportStatus,
  } = useCalculate();
  const gap = monkFrevos - bodyCosts;

  const toolTipGap = (
    <>
      <FontAwesomeIcon
        icon={faInfoCircle}
        size="1x"
        id="toolTipReport"
        className="info-icon position-absolute ml-n2 mt-1"
        onClick={() => setSecondTooltipOpen((prev) => !prev)}
      />
      <Tooltip
        placement="bottom"
        isOpen={secondtooltipOpen}
        target="toolTipReport"
        toggle={() => !isMobile && setSecondTooltipOpen((prev) => !prev)}
      >
        {t('tooltipGapValue')}
      </Tooltip>
    </>
  );

  return (
    <div className="pricing-info mt-3">
      <Table className="hide-border-top">
        <thead>
          <tr className="hide-border">
            <td />
            <td className="upper-title hr-horizontal text-right">{t('adviced_values')}</td>
            <td className="upper-title text-left">
              <span className="success ml-1">{t('your_values')}</span>
            </td>
          </tr>
        </thead>
        <tbody>
          <tr className="hide-border">
            <td className="label">{t('market_value_corrected')}</td>
            <td className="text-right hr-horizontal value" border="true">
              {marketValue ? <span>{currencySign(marketValue)}</span> : ''}
              <small className="info-text nowrap">
                {t('on')} {moment(userPricing.entryStockDate).format('DD/MM/YYYY')}
              </small>
            </td>
            <td className="text-left">
              <Input
                type="number"
                className="form-control pricing rounded"
                id="value"
                onChange={(e) => setValue({ marketValue: e.target.value })}
                value={userPricing.marketValue || 0}
                disabled={readOnly}
              />
            </td>
          </tr>
          <tr className="hide-border">
            <td className="label">{t('planed_delay')}</td>
            <td className="text-right hr-horizontal value">
              {autobizRotation && <span>{`${autobizRotation} ${t('p_day')}`}</span>}
            </td>
            <td className="text-left">
              <div className="pricing result">
                <Input
                  type="select"
                  className="form-control rounded select"
                  id="value"
                  onChange={(e) => setValue({ plannedDelay: e.target.value })}
                  value={userPricing.plannedDelay}
                  disabled={readOnly}
                >
                  {listPlanedDelay.map((j) => (
                    <option value={j} key={j}>
                      {j}
                    </option>
                  ))}
                </Input>
              </div>
            </td>
          </tr>
          <tr className="hide-border">
            <td className="label">{t('tradeInPricing')}</td>
            <td className="text-right hr-horizontal">
              <div className="pricing result value">
                {tradeInAutobiz ? <span>{currencySign(tradeInAutobiz)}</span> : ''}
              </div>
            </td>
            <td>
              <div className="pricing result value">
                {tradeInUser > 0 ? <span>{currencySign(tradeInUser)}</span> : <span>{currencySign(0)}</span>}
              </div>
              {rotation === 0 && (
                <>
                  <FontAwesomeIcon
                    icon={faInfoCircle}
                    size="1x"
                    id="toolTipRotation"
                    className="info-icon position-absolute ml-n2 mt-1"
                    onClick={() => setTooltipOpen((prev) => !prev)}
                  />
                  <Tooltip
                    placement="bottom"
                    isOpen={tooltipOpen}
                    target="toolTipRotation"
                    toggle={() => !isMobile && setTooltipOpen((prev) => !prev)}
                  >
                    {t('toolTipRotation')}
                  </Tooltip>
                </>
              )}
            </td>
          </tr>
          <tr>
            <td className="label">
              {t('refurbishment_pricing')}
              {isMobile && (
                <>
                  <div className="report d-flex mob-display mt-3">
                    <span className="text-black ">{t('buyer')}</span>

                    <span className="text-black text-italic smaller-font">
                      {t('bodyCostsTextPricing')}&nbsp;
                      <b>{currencySign(bodyCosts)}</b>
                    </span>
                  </div>
                  {monkFrevos && aiReport && monkReportStatus.status !== undefined ? (
                    <>
                      <br />
                      <div className="report d-flex mob-display">
                        <span className="text-aicolor noa-color">{t('titleAi')}</span>

                        <span className="text-black text-italic smaller-font">
                          {t('reconCostAi')}&nbsp;
                          <b>{currencySign(monkFrevos)}</b>
                        </span>
                      </div>
                      <br />
                      <div className="report d-flex mob-display">
                        <p className="text-gap">
                          {t('gapValue')}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                          {toolTipGap}
                        </p>

                        <span className="text-black smaller-font">
                          <b>{currencySign(Math.abs(gap))}</b>
                        </span>
                      </div>
                    </>
                  ) : (
                    ''
                  )}
                </>
              )}
              {!isMobile && (
                <>
                  <Row className="report">
                    <Col xs="3">
                      <span className="text-black ">{t('buyer')}</span>
                    </Col>
                    <Col xs="9" className="text-black text-right">
                      <span className="text-italic">{t('bodyCostsTextPricing')}&nbsp;</span>
                      <span>
                        <b>{currencySign(bodyCosts)}</b>
                      </span>
                    </Col>
                  </Row>
                  {monkFrevos && aiReport && monkReportStatus.status !== undefined ? (
                    <>
                      <br />
                      <Row className="report">
                        <Col xs="3">
                          <span className="text-aicolor noa-color">{t('titleAi')}</span>
                        </Col>
                        <Col xs="9" className="text-black text-right">
                          <span className="text-italic">{t('reconCostAi')}&nbsp;</span>
                          <span>
                            <b>{currencySign(monkFrevos)}</b>
                          </span>
                        </Col>
                      </Row>
                      <br />
                      <Row className="report">
                        <Col xs="8" sm="9">
                          <p className="text-gap">
                            {t('gapValue')}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            {toolTipGap}
                          </p>
                        </Col>
                        <Col xs="4" sm="3" className="text-right">
                          <span className="text-black">
                            <b>{currencySign(Math.abs(gap))}</b>
                          </span>
                        </Col>
                      </Row>
                    </>
                  ) : (
                    ''
                  )}
                </>
              )}
            </td>
            <td className="text-right hr-horizontal value">
              {refurbishmentCostCarcheck ? <span>{currencySign(refurbishmentCostCarcheck)}</span> : ''}
            </td>
            <td className="text-left">
              <Input
                type="number"
                className="form-control pricing rounded"
                id="value"
                onChange={(e) => setValue({ refurbishingCosts: e.target.value })}
                value={userPricing.refurbishingCosts || 0}
                disabled={readOnly}
              />
            </td>
          </tr>
        </tbody>
        <tfoot>
          <tr className="hide-border">
            <td className="label">{t('trade_in_value')}</td>
            <td className="text-right hr-horizontal label">
              {pricingAutobizResult && <span>{currencySign(pricingAutobizResult)}</span>}
              <small className="info-text">
                {t('on')} {moment(userPricing.entryStockDate).format('DD/MM/YYYY')}
              </small>
            </td>
            <td className="text-left">
              <div className="pricing result label">
                <span>{pricingUserResult && currencySign(pricingUserResult)}</span>
              </div>
            </td>
          </tr>
          {showET && (
            <tr className="hide-border">
              <td className="label">{t('vat_spain')}</td>

              <td className="text-right hr-horizontal" />
              <td className="text-left">
                <div className="pricing result">
                  <Input
                    type="select"
                    className="form-control rounded select"
                    id="value"
                    onChange={(e) => setValue({ vatSpain: e.target.value })}
                    value={userPricing.vatSpain}
                    disabled={readOnly}
                  >
                    {Object.entries(listVat).map(([vat, label]) => (
                      <option value={vat} key={vat}>
                        {t(label)}
                      </option>
                    ))}
                  </Input>
                </div>
              </td>
            </tr>
          )}
          {userPricing && userPricing.vatSpain !== 'REBU' && (
            <tr>
              <td className="label">{t('my_valuation_ET')}</td>

              <td className="text-right hr-horizontal label">
                <span>{!!prixEt && currencySign(prixEt?.toLocaleString())}</span>
              </td>
              <td className="text-left">
                <div className="pricing result label">
                  <span>{!!prixEtUser && currencySign(prixEtUser?.toLocaleString())}</span>
                </div>
              </td>
            </tr>
          )}
        </tfoot>
      </Table>
    </div>
  );
};

Calculate.propTypes = {
  readOnly: PropTypes.bool.isRequired,
  monkFrevos: PropTypes.number.isRequired,
};
export default Calculate;
